<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "connectAudit"
}
</script>

<style scoped>
</style>
